import { Button, Grid } from '@mui/material';
import AssociationsListToBeAdded from './AssociationsListToBeAdded';
import AssignEntityDialog from './AssignEntityDialog';

type Props = {
  associationData: any;
  setAssociationData: any;
  removeAssociation: (id: any) => void;
  supportedRecordTypes: any[];
  providers: any[];
  form: any;
  open: boolean;
  handleCloseDialog: () => void;
  handleCustodianSelect: (item: any) => void;
  handleClickOpen: () => void;
  showAddButton: boolean;
  entityLabel?: string;
  formKeyName?: string;
};

export default function AssociationsControls({
  associationData,
  setAssociationData,
  removeAssociation,
  supportedRecordTypes,
  providers,
  form,
  open,
  handleCloseDialog,
  handleCustodianSelect,
  handleClickOpen,
  showAddButton,
  entityLabel = 'Custodian',
  formKeyName = 'entityAssociations',
}: Props) {
  return (
    <Grid container>
      <Grid item xs={12}>
        <AssociationsListToBeAdded
          associationData={associationData}
          setAssociationData={setAssociationData}
          removeAssociation={removeAssociation}
          recordTypes={supportedRecordTypes}
          providers={providers}
          form={form}
          formKeyName={formKeyName}
        />
        <AssignEntityDialog
          open={open}
          handleClose={handleCloseDialog}
          associatedEntities={form.values.entityAssociations}
          onItemSelected={(item: any) => handleCustodianSelect(item)}
          entityLabel={entityLabel}
        />
      </Grid>
      {showAddButton && (
        <Grid item>
          <Button onClick={handleClickOpen}>Add new associate custodian</Button>
        </Grid>
      )}
    </Grid>
  );
}
